import FontAwesome from 'react-fontawesome';
import classNames from 'classnames';
import { any, oneOf } from 'prop-types';

import style from './InfoMessage.module.scss';

const ICONS_MAPPING = {
  info: 'clock-o',
  warn: 'ban',
  success: 'check',
};
const DEFAULT_ICON = ICONS_MAPPING.info;

const InfoMessage = ({ type, children }) => (
  <div className={classNames(style.alert, type)}>
    <FontAwesome
      name={ICONS_MAPPING[type] || DEFAULT_ICON}
      tag="i"
    />
    <span>{children}</span>
  </div>
);

InfoMessage.propTypes = {
  type: oneOf(['info', 'warn', 'success']),
  children: any,
};

export default InfoMessage;
